var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"mt-12",attrs:{"src":_vm.getDateImage,"height":"11vh","contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }